import clsx from 'clsx'
import type React from 'react'
import type { DataTableInstance, DataTableRowData } from '../../types'
import { parseFromValuesOrFunc } from '../../utils/utils'
import { BottomToolbar } from '../toolbar/bottom-toolbar'
import { TableSelectionInfobar } from '../toolbar/table-selection-infobar'
import { DataTableTopToolbar } from '../toolbar/top-toolbar'
import { TableContainer } from './table-container'
import './table-paper.module.css'

interface Props<TData extends DataTableRowData> extends React.HTMLAttributes<HTMLDivElement> {
  table: DataTableInstance<TData>
  itemLabel?: string
}

export const TablePaper = <TData extends DataTableRowData>({ table, ...rest }: Props<TData>) => {
  const {
    options: {
      enableBottomToolbar,
      enableTopToolbar,
      renderBottomToolbar,
      renderTopToolbar,
      selectAllLabel,
    },
  } = table
  const tablePaperProps = {
    table,
    ...rest,
  }

  return (
    <div
      {...tablePaperProps}
      className={clsx(
        'mrt-table-paper flex flex-col min-h-0 bg-background overflow-hidden duration-150 ease-in-out transition-all h-full',
        tablePaperProps?.className,
      )}
    >
      {enableTopToolbar &&
        (parseFromValuesOrFunc(renderTopToolbar, { table }) ?? (
          <DataTableTopToolbar table={table} />
        ))}
      <TableSelectionInfobar
        table={table}
        itemLabel={selectAllLabel}
        isSelectDropdown={table.options.isSelectDropdown}
      />
      <TableContainer table={table} />
      {enableBottomToolbar &&
        (parseFromValuesOrFunc(renderBottomToolbar, { table }) ?? <BottomToolbar table={table} />)}
    </div>
  )
}
